// Хранение активного профиля (см. постановку «Родители и дети»).
// Помимо id храним снапшот профиля: список профилей (GET /api/profile/profiles)
// доступен только владельцу аккаунта, поэтому в детском режиме детали профиля
// берём из снапшота.

const ACTIVE_PROFILE_ID_KEY = 'active_profile_id';
const ACTIVE_PROFILE_SNAPSHOT_KEY = 'active_profile_snapshot';

// Маркер явного выбора контекста владельца аккаунта (на экране выбора профиля).
// Отличает «выбран родительский контекст» от «профиль ещё не выбран» —
// иначе гард не пускает в родительский аккаунт (бесконечный редирект).
export const OWNER_PROFILE_MARKER = 'owner';

// Заголовок X-Active-Profile-Id не отправляется, пока выбор не сделан
export const getStoredActiveProfileId = () => {
	const id = localStorage.getItem(ACTIVE_PROFILE_ID_KEY);
	return id === OWNER_PROFILE_MARKER ? null : id;
};

export const hasStoredProfileSelection = () => localStorage.getItem(ACTIVE_PROFILE_ID_KEY) !== null;

export const getStoredActiveProfile = () => {
	try {
		const snapshot = JSON.parse(localStorage.getItem(ACTIVE_PROFILE_SNAPSHOT_KEY));
		return snapshot?.id ? snapshot : null;
	} catch (e) {
		return null;
	}
};

export const storeActiveProfile = (profile) => {
	if (!profile?.id) {
		// Явный выбор контекста владельца: маркер + очистка снапшота
		localStorage.setItem(ACTIVE_PROFILE_ID_KEY, OWNER_PROFILE_MARKER);
		localStorage.removeItem(ACTIVE_PROFILE_SNAPSHOT_KEY);
		return;
	}

	localStorage.setItem(ACTIVE_PROFILE_ID_KEY, String(profile.id));
	localStorage.setItem(ACTIVE_PROFILE_SNAPSHOT_KEY, JSON.stringify({
		id: profile.id,
		is_child: profile.is_child,
		name: profile.name,
		avatar: profile.avatar ?? null,
		bday: profile.bday ?? null,
		instruments: profile.instruments ?? [],
	}));
};

export const clearStoredActiveProfile = () => {
	localStorage.removeItem(ACTIVE_PROFILE_ID_KEY);
	localStorage.removeItem(ACTIVE_PROFILE_SNAPSHOT_KEY);
};
